module.exports = __webpack_public_path__ + "static/media/hot_mrzz.4b1d05e9.png";